package app.nestbridge.feature.main.presentation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.produceState
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import app.nestbridge.app.usecase.GetUserContextUseCase
import app.nestbridge.app.context.identity.UserContext
import app.nestbridge.feature.main.screen.MainShellEvent
import app.nestbridge.feature.main.screen.MainShellScreen
import app.nestbridge.feature.main.screen.MainShellState
import app.nestbridge.feature.main.screen.MainTab
import app.nestbridge.feature.profile.screen.ProfileScreen
import com.slack.circuit.codegen.annotations.CircuitInject
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.Assisted
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

@CircuitInject(
    screen = MainShellScreen::class,
    scope = AppScope::class
)
class MainShellPresenter @Inject constructor(
    @Assisted private val navigator: Navigator,
    private val getUserContextUseCase: GetUserContextUseCase,
): Presenter<MainShellState> {

    @Composable
    override fun present(): MainShellState {
        var selectedTab by remember { mutableStateOf(MainTab.HOME) }
        val userContextFlow by produceState<StateFlow<UserContext?>>(initialValue = MutableStateFlow<UserContext?>(null)) {
            value = getUserContextUseCase()
        }
        val userContext by userContextFlow.collectAsState()

        fun handleEvent(event: MainShellEvent) {
            when (event) {
                is MainShellEvent.TabSelected -> {
                    selectedTab = event.tab
                }

                MainShellEvent.ProfileClicked -> {
                    navigator.goTo(ProfileScreen)
                }
            }
        }

        return MainShellState(
            selectedTab = selectedTab,
            profilePictureUrl = userContext?.userProfile?.profilePictureUrl,
            userName = userContext?.userProfile?.displayName,
            eventSink = ::handleEvent
        )
    }
}
